import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, ShoppingCart } from 'lucide-react';
const notifications = [{
  name: 'Alejandra M.',
  location: 'Córdoba, Argentina'
}, {
  name: 'Diego R.',
  location: 'Medellín, Colombia'
}, {
  name: 'Valentina S.',
  location: 'Santiago, Chile'
}, {
  name: 'Fernando L.',
  location: 'Quito, Ecuador'
}, {
  name: 'Camila P.',
  location: 'Guadalajara, México'
}, {
  name: 'Martín G.',
  location: 'Asunción, Paraguay'
}, {
  name: 'Sofía T.',
  location: 'Caracas, Venezuela'
}, {
  name: 'Joaquín B.',
  location: 'San José, Costa Rica'
}, {
  name: 'Paula H.',
  location: 'Santo Domingo, Rep. Dominicana'
}, {
  name: 'Nicolás V.',
  location: 'La Paz, Bolivia'
}];
export function SocialProofPopup() {
  const [current, setCurrent] = useState<number | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    // Start loop
    const showNext = () => {
      const nextIndex = Math.floor(Math.random() * notifications.length);
      setCurrent(nextIndex);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next show (8-12 seconds later)
      const delay = Math.random() * 4000 + 8000;
      setTimeout(showNext, delay + 4000);
    };
    // Initial delay
    const initialTimer = setTimeout(showNext, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  if (current === null) return null;
  return <AnimatePresence data-id="element-155">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 20,
      x: -20
    }} className="fixed bottom-4 left-4 z-40 max-w-xs w-full" data-id="element-156">
          <div className="bg-white rounded-lg shadow-xl border-l-4 border-[#1B5E20] p-4 flex items-start gap-3 relative" data-id="element-157">
            <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" data-id="element-158">
              <X className="w-3 h-3" data-id="element-159" />
            </button>

            <div className="bg-green-100 p-2 rounded-full" data-id="element-160">
              <ShoppingCart className="w-5 h-5 text-[#1B5E20]" data-id="element-161" />
            </div>

            <div data-id="element-162">
              <p className="text-sm font-bold text-gray-900" data-id="element-163">
                {notifications[current].name}
              </p>
              <p className="text-xs text-gray-600" data-id="element-164">
                de {notifications[current].location}
              </p>
              <p className="text-xs text-[#1B5E20] font-medium mt-1" data-id="element-165">
                acaba de comprar el MegaPack
              </p>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}